// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	type:'dev',
	baseHref: "/RainbowOne/webapp/2.8/roWeb/",
	version: require('../../package.json').version,
	versions: require('../../package.json').versions,
	serverHost: 'dev.openknowledge.hk',
	appFolder: 'RainbowOne',
	dataUrl: '//dev.openknowledge.hk/RainbowOne/index.php/DataStorage/',
	apiUrl: '//dev.openknowledge.hk/RainbowOne/index.php/PHPGateway/proxy/2.8/',
	db: 'Dev',
	defaultDataId: '8383',
	defaultToken: '5A2B425B',
	blobStorage:"//okadev.blob.core.windows.net/media/",
	wsGateway:"wss://api4.openknowledge.hk:8443/dev/as3-websocket-gateway",
	resourceServer: {
		'0': '//api.openknowledge.hk/RainbowOne/',
		'1': '//okadev.blob.core.windows.net/media/',
		'22': '//rainbowone.hk/host/',
		'storage': '//dev.openknowledge.hk/RainbowOne/'
	},
	"title": "RoWeb",
	ocrService: {
		httpHost: "http://api3.openknowledge.hk:8083",
		httpsHost: "https://api3.openknowledge.hk:8088"
	},
	pdfReportService: {
		httpHost: "http://api3.openknowledge.hk:8082",
		httpsHost: "https://api3.openknowledge.hk:8090"
	},
	pdfConverterService: {
		httpHost: "http://api3.openknowledge.hk:8080",
		httpsHost: "https://api3.openknowledge.hk:8091",
	},
	ngReportService: {
		httpHost: "http://api3.openknowledge.hk:8094",
		httpsHost: "https://api3.openknowledge.hk:8095",
	},
	irtChartService: {
		httpHost: "http://api3.openknowledge.hk:8103",
		httpsHost: "https://api3.openknowledge.hk:8104"
	},
	roNodeServer: {
		httpHost: "http://ronode.azurewebsites.net",
		httpsHost: "https://ronode.azurewebsites.net",
	},
	hkedCity: {
		edconnectClientId: "ssnasf_sb",
		edconnectUrl: "https://edconnect2-sandbox.hkedcity.net/cas",
		qdcs: {
			edconnectClientId: "xpyqdcs_sb",
			edconnectUrl: "https://edconnect2-sandbox.hkedcity.net/cas"
		},
		smartchatai: {
			edconnectClientId: "myaibuddy_ymca_sb",
			edconnectUrl: "https://edconnect2-sandbox.hkedcity.net/cas",
		}
	},
	roWebSocketServer: {
		httpHost: "http://ws.openknowledge.hk/roWebSocket/dev/",
		httpsHost: "https://ws.openknowledge.hk/roWebSocket/dev/"
	},
	oupMiddleLayer: {
		httpsHost: "https://dev.e-activity.oupchina.com.hk",
		endpoint: "https://dev.account.oupchina.com.hk/",
		clientID: "dev/activityplatform",
		oupMiddleLayerServiceEndpointHttp: "//api3.openknowledge.hk:8105/api/",
		oupMiddleLayerServiceEndpointHttps: "//api3.openknowledge.hk:8106/api/"
	},
	puppeteerScreenshotServer: {
		httpHost: "http://api4.openknowledge.hk:9001",
		httpsHost: "https://api4.openknowledge.hk:9002"
	},
	oupCookies: {
		gtmId: "GTM-T8RMDLQL",
		otId: "019956f6-5e0d-7cdb-a8ec-57de5affac31-test"
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
